<!-- properties -->
<ng-container *ngIf="slideshow.assignment; else loading">
    <!-- images toggle button -->
    <div id="panel-toggle">
        <span class="icon-button" (click)="toggle('imagesOpen')" [ngClass]="{active: imagesOpen}">
            <mat-icon>insert_photo</mat-icon> 
        </span>
    </div>
    <label>Ad Creatives</label>
    <div fxLayout="row wrap" fxLayoutGap="20px" id="common-meta">
        <ng-container *ngIf="slideshow.assignment.ads && slideshow.assignment.ads.length">
            <div fxFlex class="wysiwyg ad" *ngFor="let ad of slideshow.assignment.ads; let i = index; trackBy: utils.trackByIndex">
                <ng-container *ngIf="!slideshow.locked && userCanEdit">
                    <label><span (click)="deleteAd(i)">Delete Ad</span></label>
                </ng-container>
                <!-- need to use slideshow.assignment.ads[i] instead of ad here https://stackoverflow.com/questions/60128458/strange-problem-migrating-angular-8-app-to-9 -->
                <ad-platform
                    #platforms
                    class="ad-platforms"
                    [canEdit]="userCanEdit"
                    [(ad)]="slideshow.assignment.ads[i]"
                    (adPlatformChanged)="updateAdCharacterLimits(i)">
                </ad-platform>
                <ng-container>
                    <richtext
                        value="{{ad.headline}}"
                        (valueChange)="updateAdHeadline($event, i)"
                        placeholder="Ad Headline"
                        *ngIf="!slideshow.locked && userCanEdit; else headlineEl"
                        [removeButtons]="true">
                    </richtext>
                    <ng-template #headlineEl>
                        <div [ngClass]="{faded: !ad.headline}">{{ad.headline ? ad.headline : 'Ad Headline'}}</div>
                    </ng-template>
                    <label class="word-count">{{(ad.headline || '').length}} / {{headlineCharacterLimits[i]}}<span *ngIf="!slideshow.locked && userCanEdit && headlineCharacterLimits[i] > 0" (click)="deleteAdHeadline(i)">Clear</span></label>
                    <div class="warn" *ngIf="(ad.headline || '').length > headlineCharacterLimits[i] && headlineCharacterLimits[i] > 0">
                        <mat-icon>error_outline</mat-icon>
                        <span class="message">
                            Please keep headline length at {{headlineCharacterLimits[i]}} characters or less.
                        </span>
                    </div>
                </ng-container>
                <ng-container>
                    <richtext
                        value="{{ad.description}}"
                        (valueChange)="updateAdDescription($event, i)"
                        placeholder="Ad Description"
                        *ngIf="!slideshow.locked && userCanEdit; else descriptionEl"
                        [removeButtons]="true">
                    </richtext>
                    <ng-template #descriptionEl>
                        <div [ngClass]="{faded: !ad.description}">{{ad.description ? ad.description : 'Ad Description'}}</div>
                    </ng-template>
                    <label class="word-count">{{(ad.description || '').length}} / {{descriptionCharacterLimits[i]}}<span *ngIf="!slideshow.locked && userCanEdit && descriptionCharacterLimits[i] > 0 && descriptionCharacterLimits[i] != Infinity" (click)="deleteAdDescription(i)">Clear</span></label>
                    <div class="warn" *ngIf="(ad.description || '').length > descriptionCharacterLimits[i] && descriptionCharacterLimits[i] > 0 && descriptionCharacterLimits[i] != Infinity">
                        <mat-icon>error_outline</mat-icon>
                        <span class="message">
                            Please keep description length at {{descriptionCharacterLimits[i]}} characters or less.
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngIf="slideshow.assignment.ads[i].image && slideshow.assignment.ads[i].image.url != '' && !slideshow.locked && userCanEdit">
                    <label>Ad Image<span (click)="deleteAdImage(i)">Clear</span></label>
                </ng-container>
                <image-component
                    (slideImagesChange)="updateAdImage($event, i)"
                    [canEdit]="!slideshow.locked && userCanEdit"
                    [single]="true"
                    [singleImage]="slideshow.assignment.ads[i].image"
                    [adsTab]="true">
                </image-component>
                <div class="warn" *ngIf="adImageMessages && adImageMessages[i] && adImageMessages[i] != ''">
                    <mat-icon>error_outline</mat-icon>
                    <span class="message">{{adImageMessages[i]}}</span>
                </div>
                <!-- <image-component
                    *ngIf="!slideshow.locked && userCanEdit && (!slideshow.assignment.ads[i].image || slideshow.assignment.ads[i].image.url == '')"
                    (slideImagesChange)="updateAdImage($event, i)"
                    [canEdit]="userCanEdit"
                    [single]="true"
                    [adsTab]="true"
                    [placeholderOnly]="true">
                </image-component> -->
            </div>
        </ng-container>
    </div>
    <button 
        *ngIf="!slideshow.locked && userCanEdit"
        class="add-creative faded trigger" 
        (click)="createAd()">
        <mat-icon class="add">add</mat-icon> 
        <span>New Ad</span>
    </button>
    <!-- images toggle panel -->
    <div id="panel-options" [ngClass]="{open: imagesOpen}">
        <div class="wrap">
            <image-list class="inner {{ imagesOpen ? 'open' : '' }}" (imageClick)="popImageDialog($event)"></image-list>
        </div>
    </div>
</ng-container>
<ng-template #loading>
    loading...
</ng-template>
